import { Map } from 'immutable'
import { addNewRelicAction } from 'services/app/_newrelic'
import { client as apolloClient } from 'services/apollo-graphql'
import { CREATE_EVENT_LOG } from './mutation'
import { buildServerEventLogInput } from './build-server-event-log-input'

/**
 * Persists an event via the Event Log GraphQL mutation (shared by GA4-derived events and
 * server marketing events). `jwt` is optional: when omitted, no Authorization header is sent
 * (matches Apollo auth link behavior).
 * @param {{ jwt?: string, input: { eventName: string } }} options
 */
export async function sendEventLogMutation ({ jwt, input }) {
  if (!input || !input.eventName) {
    return
  }
  try {
    await apolloClient.mutate({
      mutation: CREATE_EVENT_LOG,
      variables: {
        input,
      },
      context: {
        jwt,
      },
    })
  } catch (e) {
    const networkError = e && e.networkError
    const httpStatus = networkError && networkError.statusCode
    addNewRelicAction('EventLogMutationFailed', {
      eventName: input.eventName,
      errorMessage: e instanceof Error ? e.message : String(e),
      ...(httpStatus != null ? { httpStatus } : {}),
    })
  }
}

/**
 * Sends CREATE_SERVER_EVENT payload to Event Log GraphQL (replaces legacy v1/events REST).
 * @param {object} options
 * @param {import('immutable').Map} options.auth
 * @param {object} options.payload
 * @param {string} [options.facebookPixelTestCode]
 */
export async function sendServerEventLog (options) {
  const { auth, payload, facebookPixelTestCode } = options
  const trimmedTest = facebookPixelTestCode != null && String(facebookPixelTestCode).trim() !== ''
    ? String(facebookPixelTestCode).trim()
    : undefined
  const input = buildServerEventLogInput(payload, { testId: trimmedTest })
  if (!input) {
    return null
  }
  const authJwt = Map.isMap(auth) ? auth.get('jwt') : undefined
  await sendEventLogMutation({ jwt: authJwt, input })
  return null
}
